import { actionClient } from '@/api'

export default {

  namespaced: true,

  actions: {

    checkMainProducts({ commit }, { mainProducts }) {
      return actionClient.post('activity-check-mainproducts', { mainProducts })
    },
    refundTip({commit}, {}) {
      return actionClient.get('remind-on-sale-order')
    }
  }

}
